import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Badge = (props) => (
  <button
    className={`badge__container ${props.active ? 'badge_active_view' : ''}`}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    <span>{props.value}</span>
    {props.rightArrow}
  </button>
);
Badge.propTypes = {
  active: PropTypes.bool,
  value: PropTypes.string,
  onClick: PropTypes.func,
  rightArrow: PropTypes.func,
  disabled: PropTypes.bool,
};
Badge.defaultProps = {
  active: false,
  value: null,
  onClick: () => {},
  rightArrow: null,
  disabled: false,
};

export default Badge;
